import React from 'react';
import { connect } from 'react-redux';
import TrackedButton from '../Buttons/TrackedButton';
import { toggleCommentsWidth } from '../../actions/uiPreferences';
import PropTypes from 'prop-types';

const CommentsCollapsibleHeaderTitle = ({ onToggleCommentsWidth, commentsFullWidth }) => (
  <span className="row" style={{ marginRight: 30 }}>
    <span className="col">
      <h2>Discussion</h2>
      <TrackedButton
        className="btn btn-sm btn-link text-dark pl-2"
        style={{ textDecoration: 'underline' }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onToggleCommentsWidth();
        }}
        title={commentsFullWidth ? 'Show info panels' : 'Show Comments only'}
        action="Toggle comments width"
      />
    </span>
    <span className="col-auto ml-auto">
      <TrackedButton
        className="btn btn-sm btn-link text-dark p-0"
        style={{ width: 30 }}
        type="link"
        to="/help"
        title={'Go to frequently asked questions'}
        action="Clicked FAQ icon"
      >
        <img
          src="https://media.explore.org/logos/faq-1589482168935.svg"
          className="clickable"
          alt="Frequently asked questions"
          style={{ width: '100%' }}
        />
      </TrackedButton>
    </span>
  </span>
);

CommentsCollapsibleHeaderTitle.propTypes = {
  onToggleCommentsWidth: PropTypes.func.isRequired,
  commentsFullWidth: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    commentsFullWidth: state.uiPreferences.commentsFullWidth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleCommentsWidth: () => dispatch(toggleCommentsWidth()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommentsCollapsibleHeaderTitle);
